export default "__VITE_ASSET__C63KS8JJ__"